import React from 'react'

export default function PaymentPreview() {
	return (
		<React.Fragment></React.Fragment>
	)
}